<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="12"
    height="12"
    viewBox="0 0 12 12"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M7.0575,6C7.0575,6,9.525,3.5324999999999998,9.525,3.5324999999999998C9.6675,3.3975,9.75,3.21,9.75,3C9.75,2.5875,9.4125,2.25,9,2.25C8.79,2.25,8.6025,2.3325,8.467500000000001,2.4675C8.467500000000001,2.4675,6,4.9425,6,4.9425C6,4.9425,3.5324999999999998,2.4675,3.5324999999999998,2.4675C3.3975,2.3325,3.21,2.25,3,2.25C2.5875,2.25,2.25,2.5875,2.25,3C2.25,3.21,2.3325,3.3975,2.4675,3.5324999999999998C2.4675,3.5324999999999998,4.9425,6,4.9425,6C4.9425,6,2.475,8.467500000000001,2.475,8.467500000000001C2.3325,8.6025,2.25,8.79,2.25,9C2.25,9.4125,2.5875,9.75,3,9.75C3.21,9.75,3.3975,9.6675,3.5324999999999998,9.532499999999999C3.5324999999999998,9.532499999999999,6,7.0575,6,7.0575C6,7.0575,8.467500000000001,9.525,8.467500000000001,9.525C8.6025,9.6675,8.79,9.75,9,9.75C9.4125,9.75,9.75,9.4125,9.75,9C9.75,8.79,9.6675,8.6025,9.532499999999999,8.467500000000001C9.532499999999999,8.467500000000001,7.0575,6,7.0575,6C7.0575,6,7.0575,6,7.0575,6Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'SmallCross11',
} as DefineComponent
</script>
